import { ISearchRequestFetchingAction, FILTERS_SEARCH_SEARCH_REQUEST_FETCHING } from './types';

export function setLoading(): ISearchRequestFetchingAction {
  return {
    type: FILTERS_SEARCH_SEARCH_REQUEST_FETCHING,
  };
}
